module.exports = __webpack_public_path__ + "img/cleaning.819c678b.jpg";